
<div id="surveys-search-box" class="row">
  <mat-form-field appearance="outline" style="width: 100%;">
    <mat-label for="qa-search-surveys">{{ placeholder | translate:locale.language}}</mat-label>
    <input matInput type="any" id="qa-search-surveys" [formControl]="searchControl" [matAutocomplete]="autoSurveys"/>
    <button *ngIf="searchControl.dirty" matIconSuffix mat-icon-button [attr.aria-label]="'Clear' | translate:locale.language" (click)="resetSearch()">
      <mat-spinner *ngIf="searchInProgress; else clear" diameter="14" class="search-spinner"></mat-spinner>
      <ng-template #clear><mat-icon>close</mat-icon></ng-template>
    </button>
    <mat-autocomplete #autoSurveys="matAutocomplete" (optionSelected)="onSelectionChanged($event.option.value)">
      <mat-option *ngFor="let item of searchResults" [value]="item">
        {{item.name}}
        <span *ngIf="!!item.dateCreated" class="as-grey-text">&nbsp;&nbsp;({{ item.dateCreated | fixDate | date:'short' }})</span>
      </mat-option>
    </mat-autocomplete>
  </mat-form-field>
</div>